var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "te",
      staticClass: "layout message-list column fill-height",
      attrs: { id: "te", "aria-live": "polite" }
    },
    [
      _c(
        "van-pull-refresh",
        {
          attrs: {
            disabled: _vm.isRefreshDisable,
            "success-text": "刷新成功",
            "loading-icon-size": 80
          },
          on: { refresh: _vm.onRefresh },
          scopedSlots: _vm._u([
            {
              key: "pulling",
              fn: function() {
                return [
                  _c("img", {
                    staticClass: "loadingGif",
                    attrs: { src: _vm.LoadingGif }
                  })
                ]
              },
              proxy: true
            },
            {
              key: "loosing",
              fn: function() {
                return [
                  _c("img", {
                    staticClass: "loadingGif",
                    attrs: { src: _vm.LoadingGif }
                  })
                ]
              },
              proxy: true
            },
            {
              key: "loading",
              fn: function() {
                return [
                  _c("img", {
                    staticClass: "loadingGif",
                    attrs: { src: _vm.LoadingGif }
                  })
                ]
              },
              proxy: true
            }
          ]),
          model: {
            value: _vm.loadings,
            callback: function($$v) {
              _vm.loadings = $$v
            },
            expression: "loadings"
          }
        },
        [
          _c(
            "div",
            { directives: [{ name: "scroll", rawName: "v-scroll" }] },
            _vm._l(_vm.messages, function(message) {
              return _c("message", {
                directives: [{ name: "scroll", rawName: "v-scroll" }],
                key: message.id,
                ref: "messages",
                refInFor: true,
                class: "message-" + message.type,
                attrs: {
                  "toolbar-logo": _vm.toolbarLogo,
                  id: "message",
                  message: message,
                  isTextFocus: _vm.isTextFocus
                },
                on: { scrollDown: _vm.scrollDown }
              })
            }),
            1
          ),
          _c(
            "v-flex",
            { directives: [{ name: "scroll", rawName: "v-scroll" }] },
            [
              _vm.loading
                ? _c(
                    "div",
                    [
                      _c("message-loading", {
                        attrs: { message: _vm.messages }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }